import type { Plugin } from '@nuxt/types';

const axiosPlugin: Plugin = ({ $axios, store }, inject) => {
  const api = $axios.create();

  // request interceptors
  const requestInterceptor = api.interceptors.request.use(
    config => {
      const { url, method, params, headers, baseURL } = config;
      if (process.server && !process.env.isDev) {
        // eslint-disable-next-line
        console.log('request', JSON.stringify({ url, method, params, headers, baseURL }));
      }
      // if (process.server) {
      //   api.interceptors.request.eject(requestInterceptor);
      // }
      const token = store?.state?.auth?.user?.token;
      return {
        ...config,
        params: {
          authenticity_token: token,
          ...(config.params || {}),
        },
        url: process.client ? `/api${config.url}` : config.url,
        meta: {
          requestStartedAt: new Date().getTime(),
        },
      };
    },
    error => {
      if (process.server) {
        api.interceptors.request.eject(requestInterceptor);
      }
      Promise.reject(error);
    },
  );

  // response interceptors
  const responseInterceptor = api.interceptors.response.use(
    response => {
      const {
        status,
        statusText,
        headers,
        // @ts-ignore Property 'meta' does not exist on type 'AxiosRequestConfig'
        config: { url, method, params, meta },
      } = response;
      if (process.server && !process.env.isDev) {
        // eslint-disable-next-line
        console.log(`execution time for: ${url} - ${new Date().getTime() - meta.requestStartedAt} ms`);
        // eslint-disable-next-line
        console.log('response', JSON.stringify({ status, statusText, headers, request: { url, method, params } }));
      }
      return response;
    },
    error => {
      if (process.server) {
        api.interceptors.response.eject(responseInterceptor);
      }
      return Promise.reject(error);
    },
  );

  inject('api', api);
};

export default axiosPlugin;
